export enum TipoPessoaJuridicaEnum {
  Imobiliaria = "D66FB0CF-727B-4E20-8B1E-035595719DEF",
}
